import React from 'react';
import AsyncPartnerDashboard from './async';
import AsyncPartnerDashboardDetail from './detail/async';
import SingleColumnLayout from '../../../components/layout/SingleColumnLayout';
import {Trans} from 'react-i18next';

const parent = {
  title: <Trans i18nKey="p.p.partner.title">Online Service Partner</Trans>,
  path: '/partner',
};
export default [
  <SingleColumnLayout
    exact
    key="partner-dashboard"
    path="/partner/dashboard"
    component={AsyncPartnerDashboard}
    title={<Trans i18nKey="p.p.dashboard.title">Dashboard</Trans>}
    parents={[parent]}
  />,
  <SingleColumnLayout
    exact
    key="partner-dashboard-detail"
    path="/partner/dashboard/detail/:date"
    component={AsyncPartnerDashboardDetail}
    title={<Trans i18nKey="p.p.dashboard.detail.title">Dashboard Detail</Trans>}
    parents={[parent]}
  />,
];
